import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { KpdNavigator } from '@kpd/framework-ngx';

@Component({
  selector: 'app-goto-redirect',
  template: ` <p>Redirecting...</p> `,
})
export class GotoRedirectComponent implements OnInit {
  constructor(private activatedRoute: ActivatedRoute, private navigator: KpdNavigator) {}

  private readonly actions = {
    Usermanagement: '',
    'Usermanagement.Users': 'users',
    'Usermanagement.Licenses': 'licenses',
    'Usermanagement.Roles': 'roles',
    'Usermanagement.PermissionSets': 'permissionsets',
    'Usermanagement.Permissions': 'permissions',
    'Usermanagement.Profile': 'me',
  };

  ngOnInit(): void {
    const action = this.activatedRoute.snapshot.queryParams['action'];
    this.navigator.navigateRoot([this.getRoute(action)]);
  }

  private getRoute(action: string): string {
    if (this.actions[action]) {
      return this.actions[action];
    }
    return '';
  }
}
